import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTranslatorData } from './thunk/translatorThunk';
import { ITranslatorDataType } from '@models/keyword/keywordModel';
import { reduxThunkStatus } from '@configs/restApi';

const initialState = {
  translatorResult: null as ITranslatorDataType[],
  translatorResultStatus: 'init' as reduxThunkStatus,
};

export const keywordTranslatorSlice = createSlice({
  name: 'keywordTranslator',
  initialState: initialState,
  reducers: {
    setTransLatorData: (state, { payload }: { payload: { name: string; value: string } }) => {
      const { name, value } = payload;
      const objIndex = state.translatorResult.findIndex((item) => item.value === name);
      state.translatorResult[objIndex].translatedText = value;
    },
  },
  extraReducers: {
    // TranslatorData fetch
    [fetchTranslatorData.pending.type]: (state, { meta: { requestStatus } }) => {
      state.translatorResultStatus = requestStatus;
    },
    [fetchTranslatorData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.translatorResultStatus = requestStatus;
      state.translatorResult = payload;
    },
  },
});

export const { setTransLatorData } = keywordTranslatorSlice.actions;
export const keywordTranslatorSliceName = keywordTranslatorSlice.name;
export default keywordTranslatorSlice.reducer;
